import {
  ROUTE_WASABI_HOME,
  ROUTE_WASABI_COURSE_LIST,
  ROUTE_WASABI_COURSE_INFO,
  ROUTE_WASABI_INSTITUTION_LIST,
  ROUTE_WASABI_INSTITUTION_INFO,
  ROUTE_WASABI_USER_LIST,
  ROUTE_WASABI_USER_INFO,
  ROUTE_WASABI_EMAIL_TEMPLATES,
  ROUTE_WASABI_PAYMENTS,
  ROUTE_WASABI_SUBSCRIPTIONS,
} from '../../../ReduxStorage/routeActions';

export const WasabiPages = [
  ROUTE_WASABI_HOME,
  ROUTE_WASABI_COURSE_LIST,
  ROUTE_WASABI_COURSE_INFO,
  ROUTE_WASABI_INSTITUTION_LIST,
  ROUTE_WASABI_INSTITUTION_INFO,
  ROUTE_WASABI_USER_LIST,
  ROUTE_WASABI_USER_INFO,
  ROUTE_WASABI_EMAIL_TEMPLATES,
  ROUTE_WASABI_PAYMENTS,
  ROUTE_WASABI_SUBSCRIPTIONS,
];

export const COURSE_LIST_PAGINATION_SIZE = 25;

export const MENU_ITEMS = [
  {
    label: 'Home',
    isActive: (props) => props.type === ROUTE_WASABI_HOME,
    action: {
      type: ROUTE_WASABI_HOME,
      params: {},
    },
  },
  {
    label: 'Courses',
    isActive: (props) => {
      return (
        props.type === ROUTE_WASABI_COURSE_LIST ||
        props.type === ROUTE_WASABI_COURSE_INFO
      );
    },
    action: {
      type: ROUTE_WASABI_COURSE_LIST,
      params: {},
    },
  },
  {
    label: 'Institutions',
    isActive: (props) => {
      return (
        props.type === ROUTE_WASABI_INSTITUTION_LIST ||
        props.type === ROUTE_WASABI_INSTITUTION_INFO
      );
    },
    action: {
      type: ROUTE_WASABI_INSTITUTION_LIST,
      params: {},
    },
  },
  {
    label: 'Users',
    isActive: (props) => {
      return (
        props.type === ROUTE_WASABI_USER_LIST ||
        props.type === ROUTE_WASABI_USER_INFO
      );
    },
    action: {
      type: ROUTE_WASABI_USER_LIST,
      params: {},
    },
  },
  {
    label: 'Email Templates',
    isActive: (props) => {
      return props.type === ROUTE_WASABI_EMAIL_TEMPLATES;
    },
    action: {
      type: ROUTE_WASABI_EMAIL_TEMPLATES,
      params: {},
    },
  },
  {
    label: 'Subscriptions',
    isActive: (props) => {
      return props.type === ROUTE_WASABI_SUBSCRIPTIONS;
    },
    isSuperUserOnly: true,
    action: {
      type: ROUTE_WASABI_SUBSCRIPTIONS,
      params: {},
    },
  },
];
